import React, { Fragment } from "react";
import { Field, FieldProps, Form, FormikProps } from "formik";
import classnames from "classnames";
import { WithTranslation, withTranslation } from "react-i18next";

import { EditPrizeSupplierFormValues as FormValues } from "./Edit";

import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";

import IconClose from "@material-ui/icons/Close";

import Stepper from "components/common/stepper/Stepper";

const FormComponent = ({
  formikProps,
  formikProps: { errors, touched, isSubmitting },
  close,
  t,
  translationPath
}: {
  formikProps: FormikProps<FormValues>;
  close: (event: any) => void;
  translationPath: string;
} & WithTranslation) => (
  <Form className="d-flex flex-column h-100">
    <div className="d-flex flex-column h-100">
      <div
        className="d-flex py-2 px-3 justify-content-between align-items-center"
        style={{ borderBottom: "1px solid #dadce0" }}
      >
        <IconButton onClick={close}>
          <IconClose fontSize="small" />
        </IconButton>
        <Button
          type="submit"
          color="secondary"
          variant="contained"
          size="small"
          className="p-2"
          disabled={!formikProps.isValid || isSubmitting}
        >
          {t(`${translationPath}.createButton`)}
        </Button>
      </div>
      <div
        className="flex-grow-1 py-4 px-5 overflow-auto"
        style={{ backgroundColor: "rgb(241, 243, 244)" }}
      >
        <Stepper
          titles={t(`${translationPath}.stepper.titles`, {
            returnObjects: true
          })}
          steps={[
            <Fragment>
              <section className="box rounded p-3 mb-2">
                <p className="box__description mb-1">
                  {t(`${translationPath}.fields.priceMargin.label`)}{" "}
                  <small>
                    ({t(`${translationPath}.fields.priceMargin.description`)})
                  </small>
                </p>
                <section className="d-flex flex-column">
                  <Field
                    name="priceMargin"
                    render={({ field }: FieldProps<FormValues>) => (
                      <TextField
                        {...field}
                        inputProps={{
                          className: "px-2"
                        }}
                        className={classnames("bg-white m-0", {
                          "is-valid":
                            !errors.priceMargin && touched.priceMargin,
                          "is-invalid":
                            errors.priceMargin && touched.priceMargin
                        })}
                        tabIndex={2}
                      />
                    )}
                  />
                  {errors.priceMargin && touched.priceMargin && (
                    <div className="d-flex invalid-feedback">
                      {t(`${translationPath}.fields.priceMargin.error`)}
                    </div>
                  )}
                </section>
              </section>
            </Fragment>,
            <Fragment>
              <section className="box rounded p-3 mb-2">
                <p className="box__description mb-1">
                  {t(`${translationPath}.fields.webhook.label`)}
                </p>
                <section className="d-flex flex-column">
                  <Field
                    name="webhook"
                    render={({ field }: FieldProps<FormValues>) => (
                      <TextField
                        {...field}
                        inputProps={{
                          className: "px-2"
                        }}
                        className={classnames("bg-white m-0", {
                          "is-valid": !errors.webhook && touched.webhook,
                          "is-invalid": errors.webhook && touched.webhook
                        })}
                        tabIndex={2}
                      />
                    )}
                  />
                  {errors.priceMargin && touched.priceMargin && (
                    <div className="d-flex invalid-feedback">
                      {t(`${translationPath}.fields.priceMargin.error`)}
                    </div>
                  )}
                </section>
              </section>
            </Fragment>
          ]}
        />
      </div>
    </div>
  </Form>
);

export default withTranslation()(FormComponent);
